export const shopifyComponentProductPairsCopy = {
    productPairsMostCommon: 'Most common pair',
    productPairsShowAll: 'Show all {count} pairs',
    productPairsShowFewer: 'Show fewer pairs',
    productPairsShowDetails: 'Show details',
    productPairsHideDetails: 'Hide details',
    productPairsRateOrdersWithProduct: 'Orders that included {product}',
    productPairsRateWith: 'With {partner} · {percent}%',
    productPairsRateWithout: 'Without {partner} · {percent}%',
    productPairsRateNoWithoutOrders: 'No orders without {partner} to compare',
};
//# sourceMappingURL=product-pairs.js.map